/**
 * Case configurator main file and staring point
 *
 * @author  Micha Krapp
 * @version 2.0.0
 * @package megacase
 */

/**
 * jQuery loaded through wordpress in compatibility mode
 * @type {jQuery}
 */
$ = jQuery;

window.ThomannConfigurator = require('@thomann/caseconfigurator');

/**
 * changed to global vars in files:
 * ./bin/Detector.js
 * ./bin/three.js
 * ./bin/tween.min.js
 */
require("./bin/tween.min");

require("expose-loader?Hammer!./bin/hammer");
//require("expose-loader?Hammer!./bin/update/hammer.min");

require("./bin/Detector");
require("./bin/THREEx.screenshot");

require("./bin/three");
//window.THREE = require("./bin/update/three.min");

require("./bin/OBJLoader");
//require("./bin/update/OBJLoader2");

require("./bin/MTLLoader");
//require("./bin/update/MTLLoader2");

//TODO: deprecated
require("./bin/OBJMTLLoader");

require("./bin/OrbitControls");
//require("./bin/update/OrbitControls2");

/**
 * CASEFACTORY
 */
window.ThomannCasefactory_ui = require('../caseconfigurator-ui');

var resolve_parameter = require('./components/i18n/resolveParameter');

window.ThomannCasefactory_ui.dynamicRequire.register({
    'react': require('react'),
    'Mssg.jsx': require('./components/i18n/Mssg.jsx').default,

    'AccordionTab.jsx': require('./components/UI/AccordionTab.jsx'),
    'RangeSliderv2.jsx': require('./components/UI/RangeSliderv2.jsx'),
    'RangeSliderv3.jsx': require('./components/UI/RangeSliderv3.jsx'),
    'Select.jsx'      : require('./components/UI/Select.jsx'),
    'SVGIcon.jsx': require("./components/UI/SVGIcon.jsx").default,

    'resolveLanguage': function( key, parameter ) {
        return resolve_parameter( mc_i18n[ key.replace("nc_casefactory.", "") ], parameter );
    }
});

window.ThomannCasefactory = {
    mc_caseconfigurator: require('./casefactory/configurator'),
    mc_canvasControl: require('./casefactory/canvasControls'),
    mc_casefactory: require('./casefactory/casefactory')
};


// document ready
$(document).ready(function(){

    $( document ).on( 'click', 'div.lr-casefactory-choices-sliders-dimensions h3', function() {
        $( this ).next().slideToggle( 500 );
        $( this ).parent().toggleClass( 'open' );

        $( 'div.lr-casefactory-choices-color-picker.open h3' ).next().slideToggle( 500 );
        $( 'div.lr-casefactory-choices-color-picker' ).removeClass( 'open' );

        megacase_close_casefactory_tabs();
    });

    $( document ).on( 'click', 'div.lr-casefactory-choices-color-picker h3', function() {
        $( this ).next().slideToggle( 500 );
        $( this ).parent().toggleClass( 'open' );

        $( 'div.lr-casefactory-choices-sliders-dimensions.open h3' ).next().slideToggle( 500 );
        $( 'div.lr-casefactory-choices-sliders-dimensions' ).removeClass( 'open' );

        megacase_close_casefactory_tabs();
    });

    $( document ).on( 'click', 'div.lr-components-accordion-tab h3', function() {
        $( 'div.lr-casefactory-choices-sliders-dimensions.open h3' ).next().slideToggle( 500 );
        $( 'div.lr-casefactory-choices-sliders-dimensions' ).removeClass( 'open' );

        $( 'div.lr-casefactory-choices-color-picker.open h3' ).next().slideToggle( 500 );
        $( 'div.lr-casefactory-choices-color-picker' ).removeClass( 'open' );
    });
});

function megacase_close_casefactory_tabs() {
    let choices = $( '.lr-casefactory-choices' );
    choices.find( 'h3.open + div' ).slideToggle( 500 );
    choices.find( 'h3.open' ).removeClass( 'open' );
}



// WEBPACK FOOTER //
// ./js/caseconfigurator/case-configurator.js